import PropTypes from 'prop-types';

const HarvestTask = {
  id: PropTypes.number,
  name: PropTypes.string,
};

export default HarvestTask;
